import React, { ForwardedRef, forwardRef } from 'react';
import {
  Control,
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
} from 'react-hook-form';
import Input, { InputProps } from 'tradevan-ui/Input';

export interface InputEngNumControlProps<K extends FieldValues = FieldValues>
  extends InputProps {
  control: Control<K> | unknown; // 無法正確判斷 geneic，先設定 unknown
  name: FieldPath<K>;
  rules?: ControllerProps<K, FieldPath<K>>['rules'];
  /** hook-form 必須啟用監聽，value 才會更新 */
  watchValue: () => void;
  /** hook-form 必須要知道 value，才能在指定位置加上 className: "active" */
  value: string;
}

const InputEngNumControl = forwardRef(
  <
    // T extends Ioption,
    // IsMulti extends boolean = false,
    // Group extends GroupBase<T> = GroupBase<T>,
    K extends FieldValues = FieldValues,
  >(
    props: InputEngNumControlProps<K>,
    ref: ForwardedRef<HTMLInputElement>,
  ): JSX.Element => {
    const { control, name, rules, value, watchValue, ...other } = props;

    watchValue();

    return (
      <Controller
        control={control as Control<K>}
        name={name}
        rules={rules}
        render={({ field }) => (
          <Input
            {...field}
            ref={ref}
            value={value}
            onChange={(e) => {
              const val = e.target.value;
              field.onChange(val);
              // if (onChange) onChange(val);
            }}
            {...other}
          />
        )}
      />
    );
  },
);

export default InputEngNumControl;
